/** Dev's learning summary aggregates sessions, not the visible assignment list.
 * Multiple attempts at one lesson remain separate; do not invent sessions for
 * assignments that have no session record. */
export function sessionProgressCounts(
  sessions: ReadonlyArray<{ lesson_status?: string }>,
) {
  return sessions.reduce(
    (counts, session) => {
      const status = (session.lesson_status || "").toLowerCase();
      if (status === "complete" || status === "completed") counts.mastered += 1;
      else if (status === "in_progress" || status === "started")
        counts.inProgress += 1;
      else counts.notStarted += 1;
      return counts;
    },
    { mastered: 0, inProgress: 0, notStarted: 0 },
  );
}
